import React from 'react';
import { useRouter } from 'next/router';
import {
  useTopRatingAgenciesContext,
} from '@/creditflowresearch/application/TopCompanies/topCompaniesContexts/TopRatingAgenciesContext';

import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import LinkTable from '@/creditflowresearch/ui/common/components/LinkTable';
import {
  topCompaniesTablesCommonProps,
  getTopCompanyColumns,
} from '../common/tableConfigs';
import { getLeagueTableItemRoute } from '@/creditflowresearch/ui/components/league/LeagueTablePage/helpers';
import { getQueryString } from '@framework/router';
import { RATING_AGENCY_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';

const TopRatingAgencies = () => {
  const {
    query: {
      products,
      regions,
    },
  } = useRouter();
  const search = {
    products,
    regions,
  };
  const {
    collection,
    totalCount,
    page,
    perPage,
    paginate,
    isFetching,
    showVolume,
  } = useTopRatingAgenciesContext();
  return (
    <>
      { isFetching && <Spinner isVisible overlay /> }
      <LinkTable
        { ...topCompaniesTablesCommonProps }
        columns={ getTopCompanyColumns({
          showVolume,
          companyRole: RATING_AGENCY_NAME,
        }) }
        data={ collection }
        page={ page }
        perPage={ perPage }
        totalCount={ totalCount }
        onPageChange={ (page) => paginate(page.selected) }
        isFetching={ isFetching }
        getRoutePath={ getLeagueTableItemRoute(getQueryString(search), RATING_AGENCY_NAME) }
        emptyMessageText="No Top Rating Agencies during the selected period."
        paginatorDataTest="linkTablePaginatorRatingAgencies"
        rowDataTest="linkTableRowRatingAgencies"
      />
    </>
  );
};

export default TopRatingAgencies;
